export const getColumns = state => state.columnsList;
